export const setOrderStatusIcon = (status: string) => {
  switch (status) {
    case 'В роботі':
      return './assets/images/order/clock-purple.svg';

    case 'Готовий':
      return './assets/images/order/round-check-purple.svg';

    case 'Виданий':
      return './assets/images/order/recived-status-purple.svg';

    case 'Ожидает комплектации':
      return './assets/images/order/await-complection-purple.svg';

    case 'Витяг':
      return './assets/images/order/extract-purple.svg';

    case 'Сплачено':
      return './assets/images/order/paid-purple.svg';

    case 'У виробництві':
      return './assets/images/order/recived-status-purple.svg';

    case 'Закритий':
      return './assets/images/order/closed-purple.svg';

    case 'Чекає оплати':
      return './assets/images/order/awaits-payment-purple.svg';

    case 'Укомплектовано':
      return './assets/images/order/complected-purple.svg';

    case 'Заказ отменен':
      return './assets/images/order/order-canceled-purple.svg';

    case 'Новый заказ':
      return './assets/images/order/new-order-purple.svg';

    case 'Заказ в очереди':
      return './assets/images/order/order-query-purple.svg';

    case 'Уточнение и проверка':
      return './assets/images/order/additional-info-purple.svg';

    case 'Відвантажений':
      return './assets/images/order/order-loaded.svg';

    case 'Заказ подтвержден клиентом':
      return './assets/images/order/await-client-confirmation-purple.svg';

    case 'Заказ выполнен':
      return './assets/images/order/order-completed-purple.svg';

    case 'Скасовано':
      return './assets/images/order/order-canceled-purple-round.svg';

    default:
      return './assets/images/order/clock-purple.svg';
  }
};
